var base_url = "https://backend-vonagevrcpev2.herokuapp.com"

$(document).ready(function () {
  console.log("jQuery loaded");
  // jQuery methods go here...
  
  if(window.location.pathname.includes("gearvr")){
    $('#enter-gearvr').addClass('disabled');
    $('#name').keyup(function(){
        if($(this).val().length !=0)
          $('#enter-gearvr').removeClass('disabled');
        else
          $('#enter-gearvr').addClass('disabled');
    })
  }

  $("#submit-button, #enter-gearvr").click(function () {
    console.log("SUBMITTED")
    var name = $('#name').val();
    var company = $('#company').val();
    var email = $('#email').val();
    if (name === "" && company === "" && email === "") {
      name = $('#name2').val();
      company = $('#company2').val();
      email = $('#email2').val();
    }
    var currentP;
    var chnlMgr = $('#chnlMgr').val();
    if (chnlMgr !== "") {
      var currentP = true;
    } else {
      currentP = false;
    }
    var typeP = $('#typeP').val();
    var companySize = $('#companySize').val();
    var vertical = $('#vertical').val();

    if(window.location.pathname.includes("gearvr")){
      email="gearvrcustomer@vonage.com" + Math.random();
    }

    console.log(name, company, email, currentP, chnlMgr, typeP, companySize, vertical);

    storeUserFormData(name, company, email, currentP, chnlMgr, typeP, companySize, vertical).then(function (user) {
      console.log("User Created! ", user);
    })
  })
});

var storeUserFormData = function (name, company, email, currentP, chnlMgr, typeP, companySize, vertical) {
  var user = {
    "name": name,
    "company": company,
    "email": email,
    "currentP": currentP,
    "chnlMgr": chnlMgr,
    "typeP": typeP,
    "companySize": companySize,
    "vertical": vertical
  }
  
  localStorage.setItem('active_user', JSON.stringify(user));

  return new Promise(function (resolve, reject) {
    $.ajax({
      url: base_url + '/user',
      type: 'GET',
      dataType: 'jsonp',
      data: user,
      success: function (data) {
        resolve(data)
      },
      error: function (err) {
        console.log('Failed!', err);
        resolve(err)
      },
      complete: function(xmlHttp) {
        // xmlHttp is a XMLHttpRquest object
        //alert(xmlHttp.status);
        if (xmlHttp.code != 200) {
          if(!window.location.pathname.includes("gearvr")){
            top.location.href = 'cardboard.html';
          }
        }
      }
    });
  })
}



// WEBPACK FOOTER //
// ./src/js/modules/formSubmit.js